// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter_grid[data-v-9b2c65fc]{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:10px}", ""]);
// Exports
module.exports = exports;
